import React from 'react';
import { Container } from 'react-bootstrap';
import '../../index.css'
import { useAppContext } from '../../Context'
import { NavMenu } from '../navigation/NavMenuContainer';
import Sidebar from '../navigation/SidebarView';

/**
 * Layout as higher-level component; displays other components as children
 * @param {any} children content to be displayed inside the layout, 
*/
const Layout = ({ children, changeLanguage }) => {
    //"isAuthenticated" is used for determining whether the navigation should be displayed 
    //if the user is logged in or not
    const { isAuthenticated } = useAppContext()

    return (
        <div>
            {isAuthenticated ? <NavMenu changeLanguage={changeLanguage}/> : null}
            {isAuthenticated ? <Sidebar /> : null}
            <Container className="container-body">
                {children}
            </Container>
        </div>
    );
}

export { Layout }
